import type { FaireProductEntity } from "../../entity_types/product";

export const p_rnkqte8unp: FaireProductEntity = {
  token: "p_rnkqte8unp",
  type: "product",
  name: "BOTANICA REED DIFFUSER",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/b250ef4e57952d3d1aded27acf2b0b0f781b40f6690b6a2729ad3f76e2ae8192.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee983efce99a9a9a86f6f9ee720daf9836945b5efb504a7fd2bc3f081ac5d573.jpeg",
    "https://cdn.faire.com/fastly/25cd4984ebc6a9e3a1cccb12e4c5b7402e03bbad9c8ab81a4c2efd935d396333.jpeg"
  ],
  priceDollars: 19,
  description: "Introducing our new reed diffusers! Fill your space with your favorite ROEN scent without the flame.\n\n[ buh-tan-i-kuh ] / a small shop that sells herbs, teas, incense and charms used for healing and spiritual purposes.\n\nThis scent envelopes you with green notes of fresh mint, tomato leaf and sage. Tempered with the subtle presence of herbal tea and a lingering hint of vanilla.\n\n• wild mint\n• sage\n• white tea\n• tomato leaf\n• vanilla\n\nRoen is hand poured in our Southern California studio. All of our products are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n3 fl oz (88 ml), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:11.926Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
